import { FC } from "react"
import PinSvg from '@/shared/assets/images/PushPin.svg'
import { getFlightWallDateInfo } from "@/shared/lib/flight-wall-time"

interface AirportInfoProps {
    timestamp: string
    name: string
    pin?: boolean
    city: string
    end?: boolean
}

export const AirportInfo: FC<AirportInfoProps> = ({ timestamp, city, name, pin, end }) => {
    const wallDateInfo = getFlightWallDateInfo(timestamp)

    return (
        <div className={`flex flex-col gap-1 ${end ? "text-end" : ""}`}>
            <div className={`flex items-center ${end ? "justify-end" : ""}`}>
                {pin &&
                    <div className="text-slate-300 mr-1">
                        <PinSvg width={24} height={24} />
                    </div>
                }
                <div className="text-xl font-medium text-color-dark">
                    {wallDateInfo?.time ?? "—"}
                </div>
            </div>
            <div className="text-sm text-slate-400">
                {city}, {name}<br />
                {wallDateInfo ? `${wallDateInfo.day} ${wallDateInfo.monthShort}, ${wallDateInfo.weekdayShort}` : "дата недоступна"}
            </div>
        </div>
    )
}